import { render, staticRenderFns } from "./JustifyContent.vue?vue&type=template&id=893af480&"
import script from "./JustifyContent.vue?vue&type=script&lang=js&"
export * from "./JustifyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports